import { objectToCamelCase } from '../utils'

import OrgChartAPI from './api'

export default class OrgChart {
  static api = OrgChartAPI.create(OrgChart)
  static readOnlyFields = ['organization_id']

  constructor({ organizationId = '', data = null } = {}) {
    Object.assign(this, {
      organizationId,
      data,
    })
  }

  static create(opts = {}) {
    return new OrgChart(opts)
  }

  static fromAPI(json = {}) {
    return new OrgChart(objectToCamelCase(json))
  }
}
